import { Button, Card, CardContent, Typography } from "@mui/material";
import React from "react";
import { FormSectionHeader } from "../../Shared/FormSectionHeader";

export const RejectedActions = (
    submitCallback: (() => void) | undefined,
    closeCallback: () => void) => {
    return (
        <Card>
            <FormSectionHeader label="Close or Resubmit Request" />
            <CardContent>
                <Typography variant="subtitle1">
                    The dispatch request was rejected. You can close this request or amend it and resubmit for approval.
                </Typography>
                <Button variant="contained" onClick={submitCallback} disabled={submitCallback === undefined}>
                    Resubmit
                </Button>
                <Button variant="outlined" onClick={closeCallback}>
                    Close
                </Button>
            </CardContent>
        </Card>
    );
};
